<div class="crud-item-page">
  <form [formGroup]="form">
    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="Select a Asset from the list" [matTooltipDisabled]="disabledTooltip(this.asset)">
          <mat-label i18n="@@type.TransferAsset.asset">Asset</mat-label>
          <mat-select formControlName="asset" id="asset"              
              (ngModelChange)="assetChanging($event)" [ngModel]="item.asset"              
              (ngModelChange)="assetChanged($event)" #asset              
              placeholder="Asset" [compareWith]="assetCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let asset of assetSelectionList" [value]="asset">
              {{asset?.assetId}} - {{asset?.description}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Asset Src Business Unit" [matTooltipDisabled]="disabledTooltip(this.assetSrcBusinessUnit)">
          <mat-label i18n="@@type.TransferAsset.assetSourceBusinessUnit">Source Business Unit</mat-label>
          <input matInput formControlName="assetSrcBusinessUnit" id="assetSrcBusinessUnit"              
              [ngModel]="item.assetSrcBusinessUnit" #assetSrcBusinessUnit              
              placeholder="Asset Src Business Unit" disabled>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Asset Src Cost Centre" [matTooltipDisabled]="disabledTooltip(this.assetSrcCostCentre)">
          <mat-label i18n="@@type.TransferAsset.assetSourceCostCentre">Source Cost Centre</mat-label>
          <input matInput formControlName="assetSrcCostCentre" id="assetSrcCostCentre"              
              [ngModel]="item.assetSrcCostCentre" #assetSrcCostCentre              
              placeholder="Asset Src Cost Centre" disabled>
        </mat-form-field>
      </span>

    </div>
    <mat-divider></mat-divider>

    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="Select a Business Unit from the list" [matTooltipDisabled]="disabledTooltip(this.businessUnit)">
          <mat-label i18n="@@type.TransferAsset.businessUnit">Target Business Unit</mat-label>
          <mat-select formControlName="businessUnit" id="businessUnit"              
              (ngModelChange)="businessUnitChanging($event)" [(ngModel)]="item.businessUnit"              
              (ngModelChange)="businessUnitChanged($event)" #businessUnit              
              placeholder="Business Unit" [compareWith]="businessUnitCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let businessUnit of businessUnitSelectionList" [value]="businessUnit">
              {{businessUnit?.buId}} - {{businessUnit?.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Select a Cost Centre from the list" [matTooltipDisabled]="disabledTooltip(this.costCentre)">
          <mat-label i18n="@@type.TransferAsset.costCentre">Target Cost Centre</mat-label>
          <mat-select formControlName="costCentre" id="costCentre"              
              (ngModelChange)="costCentreChanging($event)" [(ngModel)]="item.costCentre"              
              (ngModelChange)="costCentreChanged($event)" #costCentre              
              placeholder="Cost Centre" [compareWith]="costCentreCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let costCentre of costCentreSelectionList" [value]="costCentre">
              {{costCentre?.ccId}} - {{costCentre?.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>
  </div>
  <mat-divider></mat-divider>


    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="Created By" [matTooltipDisabled]="disabledTooltip(this.createdBy)">
          <mat-label i18n="@@type.TransferAsset.createdBy">Created By</mat-label>
          <input matInput formControlName="createdBy" id="createdBy"              
              (ngModelChange)="createdByChanging($event)" [(ngModel)]="item.createdBy"              
              (ngModelChange)="createdByChanged($event)" #createdBy              
              maxlength="40" placeholder="Created By">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Date Created" [matTooltipDisabled]="disabledTooltip(this.dateCreated)">
          <mat-label i18n="@@type.TransferAsset.dateCreated">Date Created</mat-label>
          <input matInput formControlName="dateCreated" id="dateCreated"              
              (ngModelChange)="dateCreatedChanging($event)" [(ngModel)]="item.dateCreated"              
              (ngModelChange)="dateCreatedChanged($event)" #dateCreated              
              [matDatepicker]="dateCreatedDatePicker" placeholder="Date Created">
          <mat-datepicker-toggle matSuffix [for]="dateCreatedDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #dateCreatedDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field class="comments-textarea" matTooltip="Comments" [matTooltipDisabled]="disabledTooltip(this.comments)">
          <mat-label i18n="@@type.TransferAsset.comments">Comments</mat-label>
          <textarea matInput formControlName="comments" id="comments"              
              (ngModelChange)="commentsChanging($event)" [(ngModel)]="item.comments"              
              (ngModelChange)="commentsChanged($event)" #comments              
              maxlength="1000" placeholder="Comments"></textarea>
        </mat-form-field>
      </span>
    </div>
    <mat-divider></mat-divider>

    <h2>{{approvalRejectionTitle()}}</h2>
    <div class="crud-item-section">    
      <span>
        <mat-form-field matTooltip="Approval Rejection Comment" class="crud-item-input-verywide" [matTooltipDisabled]="disabledTooltip(this.approvalRejectionComment)">
          <mat-label i18n="@@type.TransferAsset.approvalRejectionComment">Approval Rejection Comment</mat-label>
          <textarea matInput formControlName="approvalRejectionComment" id="approvalRejectionComment"  class="comments-box"             
              (ngModelChange)="approvalRejectionCommentChanging($event)" [(ngModel)]="item.approvalRejectionComment"              
              (ngModelChange)="approvalRejectionCommentChanged($event)" #approvalRejectionComment              
              maxlength="1000" placeholder="Approval Rejection Comment"></textarea>
        </mat-form-field>
      </span>

      &nbsp;&nbsp;
      <span *ngIf="approveButtonVisible()">
        <button type="button" mat-raised-button color="primary" [disabled]="disableApproval()" class="action-button"
          (click)="markApprovalOrRejection(true)">
          Approve{{item.approved ? "d" : ""}}</button>
      </span>
      &nbsp;
      <span>
        <button *ngIf="rejectButtonVisible()" type="button" mat-raised-button color="accent"
          [disabled]="disableRejection()" class="action-button" (click)="markApprovalOrRejection(false)">
          Reject</button>
      </span>
    </div>
    <mat-divider></mat-divider>

    <div>
      <span>
        <mat-form-field matTooltip="Approved Rejected By" [matTooltipDisabled]="disabledTooltip(this.approvedRejectedBy)">
          <mat-label i18n="@@type.TransferAsset.approvedRejectedBy">Approved Rejected By</mat-label>
          <input matInput formControlName="approvedRejectedBy" id="approvedRejectedBy"              
              (ngModelChange)="approvedRejectedByChanging($event)" [(ngModel)]="item.approvedRejectedBy"              
              (ngModelChange)="approvedRejectedByChanged($event)" #approvedRejectedBy              
              maxlength="40" placeholder="Approved Rejected By">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Approved Rejected Date" [matTooltipDisabled]="disabledTooltip(this.approvedRejectedDate)">
          <mat-label i18n="@@type.TransferAsset.approvedRejectedDate">Approved Rejected Date</mat-label>
          <input matInput formControlName="approvedRejectedDate" id="approvedRejectedDate"              
              (ngModelChange)="approvedRejectedDateChanging($event)" [(ngModel)]="item.approvedRejectedDate"              
              (ngModelChange)="approvedRejectedDateChanged($event)" #approvedRejectedDate              
              [matDatepicker]="approvedRejectedDateDatePicker" placeholder="Approved Rejected Date">
          <mat-datepicker-toggle matSuffix [for]="approvedRejectedDateDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #approvedRejectedDateDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
      </span>

      
        <span>
          <mat-slide-toggle floatLabel="always" appearance="none" color="primary"
              formControlName="approved" id="approved"              
              (ngModelChange)="approvedChanging($event)" [(ngModel)]="item.approved"              
              (ngModelChange)="approvedChanged($event)" #approved i18n="@@type.TransferAsset.approved" disabled>
  Approved          </mat-slide-toggle>        
        </span>
      

    </div>
   
    <mat-divider></mat-divider>
  
  </form>
</div>